<section class="overflow-x-auto">
  <table mat-table [dataSource]="actionIndexes$" class="table-1k mx-auto">
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        {{ 'REPORT.SYSTEM_TABLE.ACTION' | translate }}
        <ng-container>
          @if (!readOnly()) {
            <button mat-icon-button color="accent" (click)="addAction()">
              <mat-icon>add</mat-icon>
            </button>
          }
        </ng-container>
      </th>
      <td mat-cell *matCellDef="let action">
        <!-- does not repeat the action for each kpi -->
        <!-- <ng-container *ngIf="!action.kpiIndex || action.kpiIndex === -1"> -->
        <section class="d-flex justify-content-between align-items-center cell-title">
          <p class="d-flex align-items-center my-0">
            <strong>
              {{ actions[action.actionIndex].title }}
            </strong>
          </p>

          @if (!readOnly()) {
            <section class="me-4">
              <ng-container>
                <button mat-icon-button color="accent" (click)="editAction(action)">
                  <mat-icon [style.fontSize]="iconSize">edit</mat-icon>
                </button>
              </ng-container>
              <ng-container>
                <button mat-icon-button color="accent" (click)="removeAction(action)">
                  <mat-icon [style.fontSize]="iconSize">delete</mat-icon>
                </button>
              </ng-container>
            </section>
          }
        </section>

        <p class="text-start">
          {{ actions[action.actionIndex].description }}
        </p>
      <!-- </ng-container> -->
    </td>
  </ng-container>

  <ng-container matColumnDef="kpi">
    <th mat-header-cell *matHeaderCellDef>
      KPI
      <ng-container>
        @if (!readOnly()) {
          <button mat-icon-button color="accent" (click)="addKpi()">
            <mat-icon>add</mat-icon>
          </button>
        }
      </ng-container>
    </th>

    <td mat-cell *matCellDef="let action">
      @if (action.kpiIndex !== -1) {
        <section class="d-flex justify-content-between align-items-center cell-title">
          <p class="d-flex align-items-center my-0">
            <strong>
              {{ actions[action.actionIndex].kpis[action.kpiIndex].title }}
            </strong>
          </p>
          @if (!readOnly()) {
            <section class="me-4">
              <button mat-icon-button color="accent" (click)="editKpi(action)">
                <mat-icon [style.fontSize]="iconSize">edit</mat-icon>
              </button>
              <button mat-icon-button color="accent" (click)="removeKpi(action)">
                <mat-icon [style.fontSize]="iconSize">delete</mat-icon>
              </button>
            </section>
          }
        </section>
      }

      @if (action.kpiIndex !== -1) {
        <p class="text-start">
          @if (actions[action.actionIndex].kpis[action.kpiIndex].description; as kpiDescription) {
            <span class="fw-bold">Note: </span>{{ kpiDescription }}
          }
        </p>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="progress">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORT.SYSTEM_TABLE.PROGRESS' | translate }}</th>
    <td mat-cell *matCellDef="let action">
      @if (action.kpiIndex !== -1) {
        <p>
          @if (isQuantitativeKpi(actions[action.actionIndex].kpis[action.kpiIndex])) {
            {{ actions[action.actionIndex].kpis[action.kpiIndex].progress }} / {{asQuantitativeKpi(actions[action.actionIndex].kpis[action.kpiIndex]).target}}
          } @else {
            {{ actions[action.actionIndex].kpis[action.kpiIndex].getResult() + '%' }}
          }
        </p>
      }
    </td>
  </ng-container>

  <!-- <ng-container matColumnDef="target">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORT.SYSTEM_TABLE.TARGET' | translate }}</th>
    <td mat-cell *matCellDef="let action">
      @if (action.kpiIndex !== -1) {
        <p>
          @if (isQuantitativeKpi(actions[action.actionIndex].kpis[action.kpiIndex])) {
            {{asQuantitativeKpi(actions[action.actionIndex].kpis[action.kpiIndex]).target}}
          } @else {
            {{asQualitativeKpi(actions[action.actionIndex].kpis[action.kpiIndex]).target + '%'}}
          }
        </p>
      }
    </td>
  </ng-container> -->

  <!-- <ng-container matColumnDef="results">
    <th mat-header-cell *matHeaderCellDef>{{ 'REPORT.SYSTEM_TABLE.RESULT' | translate }}</th>
    <td mat-cell *matCellDef="let action">
      @if (action.kpiIndex !== -1) {
        @if (
          isQuantitativeKpi(actions[action.actionIndex].kpis[action.kpiIndex])) {
            <mat-progress-bar mode="determinate"
                [matTooltip]="actions[action.actionIndex].kpis[action.kpiIndex].getResult() +' %'"
                [value]="actions[action.actionIndex].kpis[action.kpiIndex].getResult()"/>
            {{ actions[action.actionIndex].kpis[action.kpiIndex].getResult() + '%' }}
        } @else {
            <mat-progress-bar mode="determinate"
              [matTooltip]="actions[action.actionIndex].kpis[action.kpiIndex].getResult() + ' %'"
              [value]="actions[action.actionIndex].kpis[action.kpiIndex].getResult()"/>
            {{ actions[action.actionIndex].kpis[action.kpiIndex].getResult() + '%' }}
        }
      }
    </td>
  </ng-container> -->

  <tr mat-header-row *matHeaderRowDef="tableCols"></tr>
  <tr mat-row *matRowDef="let row; columns: tableCols"></tr>
</table>
</section>